var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj['v-hr'] = true, _obj[_vm.type] = true, _obj ),style:(_vm._styleObject)})}
var staticRenderFns = []

export { render, staticRenderFns }